<!--
/*******************************************************************************
*@ 화면명     : TokenOTPCertn
*@ 화면설명   : Token OTP 인증
*@ 사용전문   : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <NOSComponent ref="NOS_COMPONENT" :component="this.NOS_INSTANCE.components" />
    <!--"MOTP-01-07-05-01": "Token OTP 인증"-->
    <!--"MOTP-01-07-05-02": "지점에서 발급받은 OTP기기를 통한 인증 방법입니다.<br/>①코드 발생 버튼을 누르시고 ②표시되는 인증코드를 입력하세요. "-->
    <div class="scroll">
      <contents-header
        :bg-type="true"
        :no-radius="true"
        :title-img2="true"
        title="MOTP-01-07-05-01"
        description="MOTP-01-07-05-02"
      >
        <template #img2>
          <i class="icon icon-token-otp-touch" />
        </template>
      </contents-header>

      <article class="contents">
        <div class="form">
          <div class="form-row">
            <div class="item-tit">{{ /*OTP 기기 일련번호*/ $t("MOTP-01-07-05-03") }}</div>
            <div class="item-desc">
              <div class="form-text-field otp">
                <div class="input-text-field">
                  <input
                    type="text"
                    id="name"
                    class="form-control"
                    placeholder="12345667898"
                    readonly="true"
                    :value="getCheckOtp.in.otpUniqIdnfiNo"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-text-field">
            <label for="name" class="form-label">{{ /*인증코드 (6자리)*/ $t("MOTP-01-07-05-04") }}</label>
            <div class="input-text-field">
              <!-- <input
                type="tel"
                id="name"
                class="form-control"
                placeholder="6자리 입력"
                :value="getCheckOtp.in.otp"
                maxlength="6"
                @input="$store._mutations['auth/commMotpCertn/mut005_commMotpCertn'][0]({ key: 'otp', value: $event.currentTarget.value })"
              />-->
              <otp-input :NOS_INSTANCE_REFERANCE="NOS_INSTANCE" :isInputHidden="false" />
            </div>
          </div>
        </div>
      </article>
      <!-- {{getCheckOtp}} -->
    </div>
    <div class="btn-area--full fixed">
      <button
        :class="`btn md ${getCheckOtp.in.otpUniqIdnfiNo !== '' && getCheckOtp.in.otp.length === 6 ? 'normal' : 'disabled'}`"
        v-on:click="FN001"
      >{{ /*인증하기*/ $t("MOTP-01-07-05-05") }}</button>
    </div>
    <!-- action sheet 들어 가는 곳 -->

    <!--// end -->
  </article>
</template>
<style type="scss" scoped></style>
<script>
import { mapGetters, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import Common from "@/components/basic/Common";
import NOSComponent from "@/components/page/pluginFree/NOSComponent";
import NOSController from "@/components/page/pluginFree/NOSController";
import OtpInput from "@/components/page/common/OtpInput";

export default {
  extends: Common,
  name: "TokenOTPCertn",
  props: {
    bizDscd: {
      type: String,
      required: true,
    },
    successFnc: {
      type: Function,
      required: true,
    },
    failFnc: {
      type: Function,
      required: false,
    },
  },
  components: {
    NOSComponent,
    OtpInput,
  },
  computed: {
    // 세션정보를 가져옴.
    ...mapFields(["sessionInfo"]),
    ...mapGetters("auth/commMotpCertn", ["getCheckOtp"]),
  },
  created() {},
  mounted() {
    // 초기화
    this.act012_commMotpCertn();
    // tokenOTP 일련번호
    this.act011_commMotpCertn();
    this.NOS_INSTANCE.init();
    this.$store.state.common.supplCertn.cmmCertn.bizDscdForNosKeypadOtp = "TokenOTPCertn"; // NOSKeypadOTP.vue 에서 사용.
    this.$store.state.auth.commMotpCertn.checkOtp.in.bizDscd = this.bizDscd; // act010_commMotpCertn 에서 사용.
    this.$store.state.auth.commMotpCertn.successFncForBiz = this.successFnc; // act010_commMotpCertn 에서 사용.
  },
  updated() {},
  data() {
    return {
      NOS_INSTANCE: new NOSController(this, {
        componentid: "NOS_COMPONENT",
        kpd: true,
      }),
    };
  },
  methods: {
    ...mapActions("auth/commMotpCertn", ["act010_commMotpCertn", "act011_commMotpCertn", "act012_commMotpCertn"]),
    /**
     * 인증하기 버튼 클릭시
     */
    FN001: async function () {
      await this.act010_commMotpCertn();
      // const rtn = await this.act010_commMotpCertn();
      // if (rtn === "success") {
      //   if (!_.isNil(this.successFnc)) {
      //     this.successFnc();
      //   }
      // }
    },
  },
};
</script>
